import { render } from "./PopUpGuide.vue?vue&type=template&id=4212ab63"
import script from "./PopUpGuide.vue?vue&type=script&lang=js"
export * from "./PopUpGuide.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__